import { cn } from "@/lib/cn";

export interface FilterChipProps {
  active: boolean;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

/** Selectable pill chip for filter/taxonomy toggles; `aria-pressed` mirrors `active`. */
export function FilterChip({ active, label, onClick, disabled }: FilterChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      disabled={disabled}
      className={cn(
        "rounded-full border px-4 py-1.5 text-sm font-medium transition-colors",
        disabled && "disabled:cursor-not-allowed disabled:opacity-40",
        active
          ? "border-flamingo/60 bg-flamingo/12 text-flamingo"
          : "border-white/12 bg-white/[0.03] text-white/60 hover:text-white/85",
      )}
    >
      {label}
    </button>
  );
}
